import { acaoSobDemanda, telaSobDemanda } from '../../nucleo/paginas/TelaSobDemanda';
import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { api } from '../../nucleo/api';
import type { ModuloWeb } from '../../nucleo/modulos';
import { CartaoIndicador } from '../../nucleo/ui/Estados';
import { dicionario } from './i18n';

/** F10: conversas abertas com mensagem não lida. */
function Indicadores() {
  const { t } = useTranslation('conversas');
  const q = useQuery({
    queryKey: ['conversas', 'indicadores'],
    queryFn: () => api<{ abertas_nao_lidas: number; mensagens_nao_lidas: number; whatsapp: number; instagram: number; sem_atendente: number }>('/api/v1/conversas/indicadores'),
    refetchInterval: 30_000,
  });
  const destino = q.data && q.data.instagram > q.data.whatsapp ? '/comercial/instagram' : '/comercial/whatsapp';
  // ROB-01 (rodada 6): o cartão é o CartaoIndicador do núcleo (§7.13): carregando mostra reticências; erro mostra o
  // traço e "Tentar de novo" no próprio cartão, em vez de ficar em "..." para sempre quando a API falha.
  const cartao = (
    <CartaoIndicador
      rotulo={t('indicadores.naoLidas')}
      consultas={[q]}
      valor={q.data ? <span className={q.data.abertas_nao_lidas ? 'text-acento' : ''}>{q.data.abertas_nao_lidas}</span> : null}
      detalhe={
        // VA-05: sem truncate; a contagem de sem atendente fica inteira e quebra para a linha seguinte quando falta espaço.
        q.data && (
          <p className="mt-1 text-xs text-tinta-3">
            <span>{t('indicadores.mensagens', { count: q.data.mensagens_nao_lidas })}</span> · <span className="whitespace-nowrap">{t('indicadores.semAtendente')}: <span className="num">{q.data.sem_atendente}</span></span>
          </p>
        )
      }
    />
  );
  // Com erro o cartão tem o botão "Tentar de novo"; botão dentro de link não é permitido, então só há link sem erro.
  if (q.isError) return cartao;
  return (
    <Link to={destino} className="grid rounded-xl hover:opacity-90">
      {cartao}
    </Link>
  );
}

const carregar0 = () => import('./Comum');
const carregar1 = () => import('./Caixa');
const carregar2 = () => import('./Respostas');
const carregar3 = () => import('./Templates');
const carregar4 = () => import('./PainelParceiro');

const AcaoNovo = acaoSobDemanda(carregar0, 'AcaoNovo');
const Caixa = telaSobDemanda(carregar1, 'Caixa');
const Respostas = telaSobDemanda(carregar2, 'Respostas');
const Templates = telaSobDemanda(carregar3, 'Templates');
const PainelParceiro = telaSobDemanda(carregar4, 'PainelParceiro');

export const modulo: ModuloWeb = {
  slug: 'conversas',
  menu: 'comercial',
  dicionario,
  abas: [
    { rotulo: 'abas.whatsapp', caminho: 'whatsapp', elemento: <Caixa key="whatsapp" canal="whatsapp" />, Acao: () => <AcaoNovo rotulo="acoes.novaConversa" />, ordem: 6 },
    { rotulo: 'abas.instagram', caminho: 'instagram', elemento: <Caixa key="instagram" canal="instagram" />, ordem: 7 },
    { rotulo: 'abas.respostas', caminho: 'respostas-rapidas', elemento: <Respostas />, Acao: () => <AcaoNovo rotulo="acoes.novaResposta" />, ordem: 8 },
    { rotulo: 'abas.templates', caminho: 'templates', elemento: <Templates />, Acao: () => <AcaoNovo rotulo="acoes.novoTemplate" permissao="conversas.admin" />, ordem: 9 },
  ],
  Indicadores,
  // M1.7 (SPEC1-03): conversas do parceiro na ficha de Cadastros.
  paineis: [{ entidade: 'cadastros.parceiro', titulo: 'painel.titulo', Componente: PainelParceiro, ordem: 40 }],
};
